import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import BriefPopularProductsByView from '../../../components/kea/widgets/BriefPopularProductsByView';
import { getPopularByView } from '../../../actions/Analytics';
import { defaultTimeframeList } from '../../../components/kea/DateRangePicker/timeframeList';

/**
 * Wrapper for BriefPopularProductsByView that auto-loads data for Home Screen
 */
const PopularProductsWidget = ({
  popularByView,
  currentShop,
  timeframe = defaultTimeframeList.last30days,
}) => {
  const dispatch = useDispatch();
  // Analytics is tenant-scoped: always start a fresh request when the shop changes.
  useEffect(() => {
    if (currentShop) {
      dispatch(getPopularByView(currentShop, timeframe));
    }
  }, [currentShop, timeframe, dispatch]);

  return (
    <BriefPopularProductsByView
      popularByView={popularByView}
      currentShop={currentShop}
    />
  );
};

PopularProductsWidget.propTypes = {
  popularByView: PropTypes.shape({
    isFetching: PropTypes.bool,
    isFetched: PropTypes.bool,
    data: PropTypes.array,
    error: PropTypes.any,
  }).isRequired,
  currentShop: PropTypes.string.isRequired,
  timeframe: PropTypes.object,
};

export default PopularProductsWidget;
